import {
    LIST_AUDIENCE_TYPES,
    LIST_AUDIENCE_TYPES_SUCCESS,
    LIST_AUDIENCE_TYPES_ERROR,
    ADD_AUDIENCE_TYPES,
    SAVE_AUDIENCE_TYPES,
    SAVE_AUDIENCE_TYPES_SUCCESS,
    SAVE_AUDIENCE_TYPES_ERROR,
    EDIT_AUDIENCE_TYPES,
    UPDATE_AUDIENCE_TYPES,
    UPDATE_AUDIENCE_TYPES_SUCCESS,
    UPDATE_AUDIENCE_TYPES_ERROR,
    DELETE_AUDIENCE_TYPES,
    DELETE_AUDIENCE_TYPES_SUCCESS,
    DELETE_AUDIENCE_TYPES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    audienceTypes: null,
    error: null,
    loading: false,
    audienceTypeSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_AUDIENCE_TYPES:
            return {
                ...state,
                loading: true
            }
        case LIST_AUDIENCE_TYPES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_AUDIENCE_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                audienceTypes: action.payload
            }
        case SAVE_AUDIENCE_TYPES:
        case DELETE_AUDIENCE_TYPES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_AUDIENCE_TYPES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_AUDIENCE_TYPES_ERROR:
        case UPDATE_AUDIENCE_TYPES_ERROR:
        case DELETE_AUDIENCE_TYPES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_AUDIENCE_TYPES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                audienceTypes: [...state.audienceTypes, action.payload]
            }
        case ADD_AUDIENCE_TYPES:
            return {
                ...state,
                audienceTypeSelected: null,
                isEdit: false
            }
        case EDIT_AUDIENCE_TYPES:
            return {
                ...state,
                audienceTypeSelected: action.payload,
                isEdit: true
            }
        case UPDATE_AUDIENCE_TYPES_SUCCESS:
        case DELETE_AUDIENCE_TYPES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                audienceTypes: state.audienceTypes.map(audienceType => 
                    audienceType.id === action.payload.id ? audienceType = action.payload : audienceType
                ),
                audienceTypeSelected: null
            }
        // case DELETE_AUDIENCE_TYPES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         audienceTypes: state.audienceTypes.filter( audienceType => audienceType.id !== action.payload)
        //     }
        default:
            return state;
    }
}